import { createSlice } from '@reduxjs/toolkit';

export type VideoSeektimeState = {
  playerRef: any;
  videoSeek: {
    videoShotIdx: number;
    time: number;
  };
  currentTime: number;
};

const initialState: VideoSeektimeState = {
  playerRef: null,
  videoSeek: {
    videoShotIdx: 0,
    time: 0
  },
  currentTime: 0
};

const videoSeektimeSlice = createSlice({
  name: 'videoSeektime',
  initialState,
  reducers: {
    setSeekVideoShot(state, action) {
      state.videoSeek = action.payload;
      if (state.playerRef) {
        state.playerRef.seek(state.videoSeek.time);
      }
    },
    setPlayerRef(state, action) {
      state.playerRef = action.payload;
      if (state.playerRef) {
        state.playerRef.seek(state.videoSeek.time);
      }
    },
    setCurrentTime(state, action) {
      state.currentTime = action.payload.currentTime;
    }
  }
});

export const { setSeekVideoShot, setPlayerRef, setCurrentTime } = videoSeektimeSlice.actions;

export const videoSeektimeReducer = videoSeektimeSlice.reducer;
